<template>
  <div id="home">
    <h1 class="h4 mt-4 mb-4 ml-3">{{ greeting }}</h1>
    <ProductSearch />
    <ul class="nav flex-column">
      <h2 class="h5 ml-4 mt-3 mb-2">Orders</h2>
      <li class="nav-item">
        <router-link class="nav-link" to="/orders">
          <span
            class="badge mr-1"
            :class="{
              'badge-success': ordersCount === 0,
              'badge-info': ordersCount >= 1,
              'badge-secondary': ordersCount === '?'
            }"
            style="font-size: 1em"
            >{{ ordersCount }}</span
          >
          {{ ordersCount === 1 ? 'Order' : 'Orders' }}
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/materialshipments">
          <span
            class="badge mr-1"
            :class="{
              'badge-success': materialShipmentsCount === 0,
              'badge-info': materialShipmentsCount >= 1,
              'badge-secondary': materialShipmentsCount === '?'
            }"
            style="font-size: 1em"
            >{{ materialShipmentsCount }}</span
          >
          {{ materialShipmentsCount === 1 ? 'Material Shipment' : 'Material Shipments' }}</router-link
        >
      </li>
      <h2 class="h5 ml-4 mt-3 mb-2">Shipments</h2>
      <li class="nav-item">
        <router-link class="nav-link" to="/shipments"
          ><span class="badge" style="font-size: 1rem;">📦</span> Shipments
        </router-link>
      </li>
      <h2 class="h5 ml-4 mt-3 mb-2">Inventory</h2>
      <li class="nav-item">
        <router-link class="nav-link" to="/expiring-items">
          <span class="badge badge-secondary mr-1" style="font-size: 1rem" v-if="expiringItems === null">
            ?
          </span>
          <span
            class="badge mr-1"
            style="font-size: 1rem"
            :class="{
              'badge-success': expiringItems.lowestExpiryDate >= 43,
              'badge-warning': expiringItems.lowestExpiryDate <= 42,
              'badge-danger': expiringItems.lowestExpiryDate <= 28,
              blink: expiringItems.lowestExpiryDate <= 28
            }"
            v-else
            >{{ expiringItems.count }}</span
          >
          <span class="ml-2">Expiring Items</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/missingproducts">
          <span
            class="badge mr-1"
            :class="{
              'badge-success': missingItemsCount === 0,
              'badge-warning': missingItemsCount >= 1,
              'badge-secondary': missingItemsCount === '?'
            }"
            style="font-size: 1em"
            >{{ missingItemsCount }}</span
          >
          Missing Items</router-link
        >
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/purchase">
          Purchase
        </router-link>
      </li>
    </ul>
    <div class="d-flex flex-column align-items-center">
      <button class="btn btn-small btn-light mb-2" @click="logout">Logout</button>
      <button class="btn btn-small btn-light mb-2" @click="refreshApp">&#x21bb; Update</button>
    </div>
    <Scanner />
  </div>
</template>

<script>
import { auth } from '@/shared/firebase'
import Scanner from '@/components/Scanner'
import ProductSearch from '@/components/ProductSearch'
import { MissingItems } from '@/helpers/Calculator'

export default {
  components: { Scanner, ProductSearch },
  computed: {
    greeting() {
      const hour = new Date().getHours()
      let daytime = hour >= 5 && hour <= 10 ? 'Morning' : 'Day'
      if (hour >= 18) daytime = 'Evening'
      return `Good ${daytime}, ${auth.currentUser.displayName || 'unknown human being'} 🔆`
    },
    ordersCount() {
      if (!this.$store.getters.isLoaded('orders')) return '?'
      return this.$store.state.orders.filter(o => !o.orderJobId).length
    },
    materialShipmentsCount() {
      if (!this.$store.getters.isLoaded('materialShipments')) return '?'
      return this.$store.getters.materialShipments.length
    },
    missingItemsCount() {
      if (!this.$store.getters.isLoaded(['orders', 'shelves'])) return '?'
      const { orders, shelves } = this.$store.state
      const missingItems = MissingItems(
        orders.filter(o => !o.orderJobId),
        shelves
      )
      if (Object.keys(missingItems).length > 0) {
        return Math.abs(Object.values(missingItems).reduce((a, b) => a + b))
      } else {
        return 0
      }
    },
    expiringItems() {
      if (!this.$store.getters.isLoaded('shelves')) return null
      let count = 0
      let lowestExpiryDate = 30
      this.$store.state.shelves.forEach(shelf => {
        Object.keys(shelf.spaces).forEach(spaceId => {
          shelf.spaces[spaceId].items.forEach(item => {
            if (item.expiryDate) {
              const today = new Date().getTime()
              const expiryDate = new Date(item.expiryDate).getTime()
              const daysTillExpired = Math.ceil((expiryDate - today) / (1000 * 3600 * 24))
              if (daysTillExpired < 30) {
                count++
                if (daysTillExpired < lowestExpiryDate) lowestExpiryDate = daysTillExpired
              }
            }
          })
        })
      })
      return {
        count,
        lowestExpiryDate
      }
    }
  },
  methods: {
    logout: function() {
      auth.signOut()
    },
    refreshApp: function() {
      window.location.reload(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-item {
  margin: 0 0 1rem;
  padding: 0.5rem;

  border: 1px #ccc solid;
  border-radius: 5px;
}
</style>
